import { render, staticRenderFns } from "./AnnouncementCarousel.vue?vue&type=template&id=349c5ada"
import script from "./AnnouncementCarousel.vue?vue&type=script&lang=js"
export * from "./AnnouncementCarousel.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementCarousel.vue?vue&type=style&index=0&id=349c5ada&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports